import { render, staticRenderFns } from "./surrender.vue?vue&type=template&id=d355acec&scoped=true&"
import script from "./surrender.vue?vue&type=script&lang=js&"
export * from "./surrender.vue?vue&type=script&lang=js&"
import style0 from "./surrender.vue?vue&type=style&index=0&id=d355acec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d355acec",
  null
  
)

export default component.exports